import React, { useState } from 'react';
//@ts-ignore
import FileUpload from './FileUpload';
import * as FilePondType from './FilepondDefinitions';
import { useTranslation } from 'react-i18next';

type FileUploaderProps = {
    allowMultiple: boolean;
    allowImagePreview: boolean;
    onFileChange: (filePaths: FilePondType.FilePondFile[]) => void;
    allowPdfs?: boolean;
};

const FileUploader = ({
    allowMultiple,
    allowImagePreview,
    onFileChange,
    allowPdfs
}: FileUploaderProps): JSX.Element => {
    const [files, setFiles] = useState<FilePondType.FilePondFile[]>([]);
    const { t } = useTranslation();

    const acceptedFileTypes = ['image/*', 'image/heic', 'image/heif'];
    allowPdfs && acceptedFileTypes.push('application/pdf');

    const onFilesChanged = (files: FilePondType.FilePondFile[]) => {
        setFiles(files);

        if (files && files.length > 0) {
            onFileChange(files);
        } else {
            onFileChange([]);
        }
    };

    const onUploadError = (
        error: FilePondType.FilePondErrorDescription,
        file?: FilePondType.FilePondFile
    ) => {
        console.log(acceptedFileTypes);
        console.error(
            `file upload error: ${JSON.stringify(
                error
            )}, file: ${JSON.stringify(file)}`
        );
    };

    return (
        <div>
            <FileUpload
                name='fileUploader1'
                labelIdle={t('filepond_label_idle')}
                labelTapToCancel={t('filepond_label_tap_to_cancel')}
                labelFileProcessing={t('filepond_label_uploading')}
                labelFileProcessingComplete={t(
                    'filepond_label_file_processing_complete'
                )}
                labelTapToUndo={t('filepond_label_tap_to_undo')}
                allowMultiple={allowMultiple}
                allowImagePreview={allowImagePreview}
                maxFileSize={'10000000'}
                files={files}
                onFilesChanged={(files: FilePondType.FilePondFile[]) =>
                    onFilesChanged(files)
                }
                server={{
                    url: './api/FileUpload/',
                    revert: 'delete',
                    process: 'upload',
                    restore: null,
                    load: null,
                    fetch: null
                }}
                onError={(
                    error: FilePondType.FilePondErrorDescription,
                    file: FilePondType.FilePondFile
                ) => onUploadError(error, file)}
                acceptedFileTypes={acceptedFileTypes}></FileUpload>
        </div>
    );
};

export default FileUploader;
